import { addErrorsAction } from "../../../actions/errors";
import * as actionTypes from "../../../constants";
import { parseServiceErrors } from "../../../services/encounter/serviceErrors";
import { systemPreferencesAPI } from "../../../services/systemPreferences";
import { checkForConcurrencyError } from "../../../utils/checks";

import type { RemoteServicesSettingsObject } from "../models/systemPreferences";

export const getRemoteServicesSettingsAction = () => (dispatch) => {
  dispatch(getRemoteServicesSettingsActionBegin());

  const error = "Cannot get remote services settings";

  return systemPreferencesAPI
    .getRemoteServicesSettings()
    .then((settings) => {
      dispatch(getRemoteServicesSettingsActionCompleted(settings));
    })
    .catch(() => {
      dispatch(getRemoteServicesSettingsActionError(error));
    });
};

export const setRemoteServicesSettingsAction =
  (name: string, _value: string, settings: RemoteServicesSettingsObject) => (dispatch) => {
    dispatch(setRemoteServicesSettingsActionBegin());

    const error = `Cannot update ${name} field`;

    return systemPreferencesAPI
      .updateRemoteServicesSettings(settings)
      .then((newVersion) => {
        const newSettings = {
          ...settings,
          ConcurrencyVersion: newVersion || settings.ConcurrencyVersion,
        };
        dispatch(setRemoteServicesSettingsActionCompleted(newSettings));
      })
      .catch((reason) => {
        const errors = parseServiceErrors(reason, error);
        if (checkForConcurrencyError(errors)) {
          dispatch(setRemoteServicesSettingsActionError(error));
        } else {
          dispatch(addErrorsAction(errors));
          dispatch(setRemoteServicesSettingsActionError(error));
        }
      });
  };

export const getRemoteServicesSettingsActionBegin = () => ({
  type: actionTypes.GET_REMOTE_SERVICES_SETTINGS_BEGIN,
});

export const getRemoteServicesSettingsActionCompleted = (value: RemoteServicesSettingsObject) => ({
  payload: value,
  type: actionTypes.GET_REMOTE_SERVICES_SETTINGS_COMPLETED,
});

export const getRemoteServicesSettingsActionError = (error: string) => ({
  payload: error,
  type: actionTypes.GET_REMOTE_SERVICES_SETTINGS_ERROR,
});

const setRemoteServicesSettingsActionBegin = () => ({
  payload: "",
  type: actionTypes.SET_REMOTE_SERVICES_SETTINGS_BEGIN,
});

const setRemoteServicesSettingsActionCompleted = (value) => ({
  payload: value,
  type: actionTypes.SET_REMOTE_SERVICES_SETTINGS_COMPLETED,
});

const setRemoteServicesSettingsActionError = (error: string) => ({
  payload: error,
  type: actionTypes.SET_REMOTE_SERVICES_SETTINGS_ERROR,
});
